export const getDefaultValues = (item) => ({
  HostOwnerActiveADSL: item?.HostOwnerActiveADSL || 0,
  HostOwnerActiveMCI: item?.HostOwnerActiveMCI || 0,
  HostOwnerActiveMTN: item?.HostOwnerActiveMTN || 0,
  HostOwnerActiveRightel: item?.HostOwnerActiveRightel || 0,
  HostOwnerPriceADSL: item?.HostOwnerPriceADSL || 0,
  HostOwnerPriceMCI: item?.HostOwnerPriceMCI || 0,
  HostOwnerPriceMTN: item?.HostOwnerPriceMTN || 0,
  HostOwnerPriceRIGHTEL: item?.HostOwnerPriceRIGHTEL || 0,
  HostOwnerReducePercentADSL: item?.HostOwnerReducePercentADSL || 0,
  HostOwnerReducePercentMCI: item?.HostOwnerReducePercentMCI || 0,
  HostOwnerReducePercentMTN: item?.HostOwnerReducePercentMTN || 0,
  HostOwnerReducePercentRightel: item?.HostOwnerReducePercentRightel || 0,
  HostOwnerLable: item?.HostOwnerLable || '',
});
